import { AuthContext, AuthProvider } from './context';
import Firebase from './firebase';

export default Firebase;

export { AuthContext, AuthProvider };
